/**
 * Manage, Onboarding templates (plan docs/plans/lms-plan.md 12.1, 12.5,
 * section 13 tab 7, 18.12, 18.24; WP-47; R14).
 *
 * Replaces WP-03's placeholder in place: tabs/manage/subviews.ts imports this
 * file's DEFAULT export (a component with no props), mounted under the Manage
 * tab's PageHeader and SegmentedTabs at /lms/manage/onboarding-templates/*
 * (plan 18.3), so it routes its own deeper path:
 *
 *   /lms/manage/onboarding-templates               the templates (TemplateList)
 *   /lms/manage/onboarding-templates/:templateId   one template: its details and
 *                                                  its ordered items (TemplateEditor)
 */
import { Navigate, Route, Routes } from 'react-router-dom';
import TemplateList from './TemplateList';
import { TemplateEditorRoute } from './TemplateEditor';
import { TEMPLATES_BASE } from './paths';

export function OnboardingTemplatesView() {
  return (
    <Routes>
      <Route index element={<TemplateList />} />
      <Route path=":templateId" element={<TemplateEditorRoute />} />
      <Route path="*" element={<Navigate to={TEMPLATES_BASE} replace />} />
    </Routes>
  );
}

export default OnboardingTemplatesView;
